export default __webpack_public_path__ + "static/media/explore.cf4d9b75.svg";